import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor para agregar token en headers
api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const PostAmoxarifado = async (datos) => {
  try {
    const response = await api.post('registroProductoAmoxarifado', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostCategory = async (datos) => {
  try {
    const response = await api.post('categoriasDeposito', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostSubCategory = async (datos) => {
  try {
    const response = await api.post('subcategoriasDeposito', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const PostDeposito = async (datos) => {
  try {
    const response = await api.post('registroDepositoAmoxarifado', datos);
    return response.data;
  } catch (error) {
    if (error.response?.data?.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const getCategoriasAmoxarifado = async () => {
  try {
    const response = await api.get('obtenerCategoria'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

 const getDatosPatrimonio= async () => {
   try {
     const response = await api.get('patrimonio/getPatrimonio');
     return response.data;
   } catch (error) {
     throw new Error('Error al obtener datos del backend:', error);
   }
 };

const getOnePatrimonio = async (serie) => {
  try {
    const response = await api.get(`getOnePatrimonio/${serie}`); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};

const getOneSerieDep = async (serie) => {
  try {
    const response = await api.get(`getOneSerieDep/${serie}`); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};


export {
  PostAmoxarifado, PostCategory, getCategoriasAmoxarifado, PostSubCategory, getOnePatrimonio,
  PostDeposito, getDatosPatrimonio, getOneSerieDep
};
